<ng-container [formGroup]="editorForm">
  <div *ngIf="loading" class="text-muted" style="font-style: italic; font-size: 0.9em">
    {{ '::Loading' | abpLocalization }}
  </div>

  <div
    *ngIf="!loading && loadError"
    class="text-danger"
    style="font-style: italic; font-size: 0.9em">
    {{ '::Error' | abpLocalization }}
  </div>

  <div
    *ngIf="!loading && !loadError && !hasItems"
    class="text-muted"
    style="font-style: italic; font-size: 0.9em">
    {{ '::NoDataFound' | abpLocalization }}
  </div>

  <ng-container *ngIf="!loading && !loadError && hasItems">
    <ng-container *ngIf="actualConfig.type == selectionType.Checkbox">
      <ng-container *ngFor="let item of items; let i = index; trackBy: trackByItemId">
        <div *ngIf="isVisible(item)" class="form-check">
          <input
            [id]="actualConfig.key + '-' + item.id + '-' + randomKey"
            class="form-check-input me-0"
            type="checkbox"
            [value]="item.id"
            (change)="onCheckChanged($event)"
            [checked]="this.value?.indexOf(item.id) > -1" />
          <label
            class="form-check-label"
            [for]="actualConfig.key + '-' + item.id + '-' + randomKey">
            {{ getLabel(item) | abpLocalization }}
          </label>
        </div>
      </ng-container>
      <div
        class="mt-2 text-danger"
        style="font-style: italic; font-size: 0.9em"
        *ngIf="errorMessage.length > 0">
        <ng-container *ngFor="let message of errorMessage; trackBy: trackByMessage">
          * {{ message }}
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="actualConfig.type == selectionType.Radio">
      <div class="form-group" style="margin-bottom: 5px">
        <div class="display-inline">
          <ng-container *ngFor="let item of items; let i = index; trackBy: trackByItemId">
            <div *ngIf="isVisible(item)" class="form-check" style="margin-right: 10px">
              <input
                [id]="actualConfig.key + '-' + item.id + '-' + randomKey"
                class="form-check-input me-0"
                type="radio"
                [value]="item.id"
                (change)="onCheckChanged($event)"
                [checked]="this.value?.indexOf(item.id) > -1"
                [name]="'entity-group-' + randomKey" />
              <label
                class="form-check-label"
                [for]="actualConfig.key + '-' + item.id + '-' + randomKey">
                {{ getLabel(item) | abpLocalization }}
              </label>
            </div>
          </ng-container>
        </div>
      </div>
      <div
        class="mt-2 text-danger"
        style="font-style: italic; font-size: 0.9em"
        *ngIf="errorMessage.length > 0">
        <ng-container *ngFor="let message of errorMessage; trackBy: trackByMessage">
          * {{ message }}
        </ng-container>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        actualConfig.type == selectionType.Combobox || actualConfig.type == selectionType.Dropdown
      ">
      <div class="form-group" [ngClass]="actualConfig.inlineCls ? 'display-inline' : ''">
        <label
          [ngClass]="labelClass"
          [for]="actualConfig.key"
          *ngIf="actualConfig.label != null && actualConfig.label != ' '">
          {{ actualConfig.label | abpLocalization }}
        </label>
        <ca-select
          class="w-100 mw-100"
          [value]="value"
          (change)="
            actualConfig.multiple === true ? onCheckChanged($event) : onSelectChange($event)
          "
          [actualConfig]="true"
          [multiple]="actualConfig.multiple"
          formControlName="editor">
          <ca-option
            *ngIf="
              actualConfig.showAllOption == null ||
              (actualConfig.showAllOption !== null && actualConfig.showAllOption)
            "
            [value]="-1">
            {{ '::All' | abpLocalization }}
          </ca-option>
          <ca-option
            *ngFor="let item of items; let i = index; trackBy: trackByItemId"
            [value]="item.id">
            {{ getLabel(item) | abpLocalization }}
          </ca-option>
        </ca-select>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
